import { enableProdMode, importProvidersFrom, isDevMode, provideCheckNoChangesConfig, provideZonelessChangeDetection } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

import { environment } from './environments/environment';
import 'hammerjs';
import { AuthenticationService } from './app/services/authentication.service';
import { DataService } from './app/services/data.service';
import { TranslateService, provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { NavigationService } from './app/services/navigation.service';
import { FileServer } from './app/services/fileserver.service';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_DAYJS_DATE_ADAPTER_OPTIONS } from './app/adapters/dayjs-date.adapter';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, HttpClientModule, withXhr } from '@angular/common/http';
import { JwtInterceptor } from './app/helpers/jwt.interceptor';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';

registerLocaleData(localeFr, 'fr');

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, BrowserAnimationsModule, HttpClientModule),
        provideTranslateService({
            fallbackLang: 'en',
            loader: provideTranslateHttpLoader({
                useHttpBackend: true,
                resources: [
                    { prefix: './assets/i18n/', suffix: '.json' },
                    { prefix: './assets/i18n/', suffix: '.static.json' }
                ]
            })
        }),
        provideZonelessChangeDetection(),
        ...(isDevMode() ? [provideCheckNoChangesConfig({ exhaustive: true, interval: 100 })] : []),
        provideRouter(routes),
        AuthenticationService,
        DataService,
        TranslateService,
        NavigationService,
        FileServer,
        { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
        { provide: MAT_DAYJS_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 2500, panelClass: ['snack-style'] } },
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ]
})
  .catch(err => console.error(err));
